import { onMounted, onUnmounted } from 'vue';
import { useMyToast } from './useMyToast';
import { getAppVersion } from '../../frontend/src/api/version';
import { useI18n } from 'vue-i18n';
import { useStorage } from '@vueuse/core';

export function useVersionCheck() {
  const { t } = useI18n()
  const { showToast } = useMyToast()
  const currentAppVersion = useStorage<string>('currentAppVersion', '')
  let intervalId: ReturnType<typeof setInterval> | null = null

  const checkVersion = async () => {
    try {
      const { data } = await getAppVersion({
        onError: res => ({ data: null, statusCode: res?.status || 500 })
      })

      if (!data?.version) return

      if (currentAppVersion.value && currentAppVersion.value !== data.version) {
        showToast(
          t('appVersion.title'),
          t('appVersion.description'),
          'success',
          '',
          undefined,
          { closeOnClick: true, timeout: false, position: 'bottom-right' }
        )
      }

      currentAppVersion.value = data.version
    } catch (error) {
      console.error('Error checking version:', error)
    }
  }

  onMounted(() => {
    checkVersion()
    intervalId = setInterval(checkVersion, 5 * 60 * 1000) // 5 min
  })

  onUnmounted(() => {
    if (intervalId) {
      clearInterval(intervalId)
    }
  })
}
